(function () {

  angular.module('DataExtractProvider', [])

    .factory('JobDefinitionModel', ['$q', '$http', 'TenantListService', 'Utils', function ($q, $http, TenantListService, Utils) {
      return function (jobDefinition) {
        var jobDefinitionModel = {
            enabled: false,
            executionCount: null,
            executionFrequency: null,
            extractPeriod: null,
            format: null,
            lastCompleted: null,
            lastStarted: null,
            lastFailure: null,
            retentionPeriod: null,
            targetType: null,
            isCreated: null,
            sqlServerConnectData: {
              databaseName: null,
              password: null,
              portNumber: null,
              serverName: null,
              ssl: null,
              user: null,
            },
            types: null,
            links: {
              self: null
            },
            _embedded: null,
            _links: null
          }
          
          if (jobDefinition) {
            populatejobDefinitionModel(jobDefinition);
          }
          
          function populatejobDefinitionModel(jobDefinition) {
            jobDefinitionModel = {
              enabled: jobDefinition.enabled ? jobDefinition.enabled : false,
              executionCount: jobDefinition.executionCount ? jobDefinition.executionCount : null,
              executionFrequency: jobDefinition.executionFrequency ? jobDefinition.executionFrequency : null,
              extractPeriod: jobDefinition.extractPeriod ? jobDefinition.extractPeriod : null,
              format: jobDefinition.format ? jobDefinition.format : null,
              lastCompleted: jobDefinition.lastCompleted ? jobDefinition.lastCompleted : null,
              lastStarted: jobDefinition.lastStarted ? jobDefinition.lastStarted : null,
              lastFailure: jobDefinition.lastFailure ? jobDefinition.lastFailure : null,
              retentionPeriod: jobDefinition.retentionPeriod ? jobDefinition.retentionPeriod : null,
              targetType: jobDefinition.targetType ? jobDefinition.targetType : null,
              isCreated: jobDefinition.sqlServerConnectData.databaseName ? true : false,
              extractInProgress: jobDefinition.extractInProgress,
              timeElapsed: null,
              sqlServerConnectData: {
                databaseName: jobDefinition.sqlServerConnectData.databaseName ? jobDefinition.sqlServerConnectData.databaseName : null,
                password: jobDefinition.sqlServerConnectData.password ? jobDefinition.sqlServerConnectData.password : null,
                portNumber: jobDefinition.sqlServerConnectData.portNumber ? jobDefinition.sqlServerConnectData.portNumber : null,
                serverName: jobDefinition.sqlServerConnectData.serverName ? jobDefinition.sqlServerConnectData.serverName : null,
                ssl: jobDefinition.sqlServerConnectData.ssl ? jobDefinition.sqlServerConnectData.ssl : null,
                user: jobDefinition.sqlServerConnectData.user ? jobDefinition.sqlServerConnectData.user : null,
              },
              types: jobDefinition.types ? jobDefinition.types : null,
              links: {
                self: jobDefinition._links.self.href,
                regeneratePassword: null
              },
              _embedded: jobDefinition._embedded,
              _links: jobDefinition._links
            }
          }

          function mapObjectToSend(jobDefinition) {
            var sqlServerConnectData = {
                databaseName: jobDefinition.sqlServerConnectData.databaseName,
                password: jobDefinition.sqlServerConnectData.password,
                portNumber: jobDefinition.sqlServerConnectData.portNumber,
                serverName: jobDefinition.sqlServerConnectData.serverName,
                user: jobDefinition.sqlServerConnectData.user
            }
            return sqlServerConnectData;
          }

          function post(url, objectToSend) {
            var defered = $q.defer();
            $http.post(url, objectToSend).then(function(response) {
              defered.resolve(response);
            }).catch(function(error){
              defered.reject(error);
            });
            
            return defered.promise;
          }
 
          jobDefinitionModel.test = function (jobDefinition) {
            var defered = $q.defer();
            var url = TenantListService.currentTenant.info._links['px:dataExtractJobDefinitionsTest'].href;
            var objectToSend = {
              sqlServerConnectData: mapObjectToSend(jobDefinition)
            } 
            
            post(url, objectToSend).then(function(response) {
              defered.resolve(response);
            }).catch(function(error){
              defered.reject(error);
            });
            return defered.promise;
          }

          jobDefinitionModel.create = function (jobDefinition) {
            var defered = $q.defer();
            var url = TenantListService.currentTenant.info._links['px:dataExtractJobDefinitions'].href + '?triggerInitially=false';
            var objectToSend = {
              targetType: jobDefinition.targetType
            }
            if (jobDefinition.targetType === 'EXTERNAL') {
              objectToSend.sqlServerConnectData = mapObjectToSend(jobDefinition);
              jobDefinitionModel.test(jobDefinition).then(function() {
                post(url, objectToSend).then(function(response) {
                  defered.resolve(response);
                }).catch(function(error){
                  defered.reject(error);
                });
              }).catch(function(error){
                defered.reject(error);
              });
            } else {
              url = url + '&createDataAccessAccount=true';
              post(url, objectToSend).then(function(response) {
                defered.resolve(response);
              }).catch(function(error){
                defered.reject(error);
              });
            }
            return defered.promise;
          }

          jobDefinitionModel.saveChanges = function (jobDefinition) {
            if (jobDefinition) {
              var patchObjectArray = Utils.getObjectsDifferencesForPatching(jobDefinitionModel, jobDefinition);
              if (jobDefinition.targetType === 'PRINTIX') {
                patchObjectArray = removeAccessAccountData(patchObjectArray);
              }
              delete patchObjectArray.extractInProgress;

              for (var i = 0; i < patchObjectArray.length; i++) {
                if (patchObjectArray[i].path === '/extractInProgress') {
                  patchObjectArray.splice(i, 1);
                }

                if (patchObjectArray[i].path === '/retentionPeriod' && patchObjectArray[i].value === '..') {
                  patchObjectArray[i] = {"op": "remove", "path": "/retentionPeriod"}
                }

              }

              if (patchObjectArray.length > 0) {
                var defered = $q.defer();
                $http.patch(jobDefinitionModel.links.self, patchObjectArray).then(function (response) {
                  replacejobDefinitionModelData(response.data)
                  defered.resolve(response);
                }).catch(function(error){
                  defered.reject(error);
                });
                return defered.promise;
              } else {
                return $q.reject();
              }
            }
          }

          // UGLY HACK caused by lazy backend *flaviu
          function removeAccessAccountData(patchObjectArray) {
            for (var i = 0; i < patchObjectArray.length; i++) {
              if (patchObjectArray[i].path === '/sqlServerConnectData/password' || patchObjectArray[i].path === '/sqlServerConnectData/user') {
                patchObjectArray.splice(i, 1);
                i--;
              }
            }

            return patchObjectArray;
          }

          function replacejobDefinitionModelData(jobDefinition) {
            var exceptions = ['_links', 'types', 'executionCount', 'created', 'nextScheduledRun'];
            for(var key in jobDefinition) {
              if (exceptions.indexOf(key) === -1) {       
                jobDefinitionModel[key] = jobDefinition[key];
              } 
            }
          }

          jobDefinitionModel.generateNewPassword = function (jobDefinition) {
            var defered = $q.defer();
            var url = jobDefinition.links.regeneratePassword;
            $http.post(url).then(function(response) {
              defered.resolve(response.data.password);
            }).catch(function(error){
              defered.reject(error);
            });
            return defered.promise;
          }

          jobDefinitionModel.delete = function (jobDefinition) {
            var defered = $q.defer();
            var url = jobDefinition.links.self;
            if (jobDefinition.targetType === 'PRINTIX') {
              url = url + '?deleteDataAccessAccount=true';
            }
            $http.delete(url).then(function(response) {
              defered.resolve(response);
            }).catch(function(error){
              defered.reject(error);
            });
            return defered.promise;
          }

          return jobDefinitionModel;
        }
      }
    ])

    .factory('AccessAccountModel', [function () {
      return function(accessAccount) {
        var accessAccountModel = {
          username: null,
          password: null,
          database: null,
          port: null,
          server: null,
          type: null,
        }

        if (accessAccount) {
          accessAccountModel = {
            username: accessAccount.username ? accessAccount.username : null,
            password: accessAccount.password ? accessAccount.password :null,
            database: accessAccount.database ? accessAccount.database :null,
            port: accessAccount.port ? accessAccount.port :null,
            server: accessAccount.server ? accessAccount.server :null,
            type: accessAccount.type ? accessAccount.type :null,
          }
        }

        return accessAccountModel; 
      }
    }])

    .service('DataExtractService', ['$http', '$q', 'TenantListService', 'JobDefinitionModel', 'AccessAccountModel',
      function ($http, $q, TenantListService, JobDefinitionModel, AccessAccountModel) {
        var dataExtractOjbect = this;
        this.jobDefinition = {
          PRINTIX: null,
          EXTERNAL: null
        };

        dataExtractOjbect.accessAccounts = function () {
          if (TenantListService.currentTenant) {
            var url = TenantListService.currentTenant.info._links['px:dataAccessAccounts'].href;
            var defered = $q.defer();
            $http.get(url).then(function (response) {
              if (mapAccessAccountsToObject(response.data)) {
                defered.resolve();
              }
            }).catch(function(error){
              defered.reject(error);
            });
            return defered.promise;
          }
        }
        
        function mapAccessAccountsToObject(accessAccounts) {
          var printixDbName = dataExtractOjbect.jobDefinition.PRINTIX.sqlServerConnectData.databaseName;
          var printixServerName = dataExtractOjbect.jobDefinition.PRINTIX.sqlServerConnectData.serverName;
          var keepLoopGoing = true;
          if (accessAccounts._embedded && accessAccounts._embedded['px:dataAccessAccountResources']) {
            angular.forEach(accessAccounts._embedded['px:dataAccessAccountResources'], function(accessAccountRaw) {
              var accessAccount = new AccessAccountModel(accessAccountRaw);
              if (keepLoopGoing) {
                if (accessAccount.database === printixDbName && accessAccount.server === printixServerName ) {
                  dataExtractOjbect.jobDefinition.PRINTIX.sqlServerConnectData.user = accessAccount.username;
                  dataExtractOjbect.jobDefinition.PRINTIX.sqlServerConnectData.password = accessAccount.password;
                  dataExtractOjbect.jobDefinition.PRINTIX.links.regeneratePassword = accessAccountRaw._links['px:regeneratePassword'].href;
                  keepLoopGoing = false;
                }
              }
            })
          } 
          return true;
        }

        dataExtractOjbect.jobDefinitions = function () {
          if (TenantListService.currentTenant) {
            var url = TenantListService.currentTenant.info._links['px:dataExtractJobDefinitions'].href;
            var defered = $q.defer();
            $http.get(url).then(function (response) {
              
              if (mapJobDefinitionsToObject(response.data._embedded)) {
                dataExtractOjbect.accessAccounts().then(function() {
                  defered.resolve();
                }).catch(function(error){});
              }
            }).catch(function(error){
              defered.reject(error);
            });
            return defered.promise;
          }
        }


        function mapJobDefinitionsToObject(jobDefinitionResources) {
          dataExtractOjbect.jobDefinition = {
            PRINTIX: null,
            EXTERNAL: null
          };

          if (jobDefinitionResources && jobDefinitionResources['px:dataExtractJobDefinitionResources']) {
            angular.forEach(jobDefinitionResources['px:dataExtractJobDefinitionResources'], function (jobDefinition) {
              
              var jobDefinition = new JobDefinitionModel(jobDefinition);
              if (jobDefinition.targetType === 'EXTERNAL') {
                dataExtractOjbect.jobDefinition.EXTERNAL = jobDefinition
              } 
              if (jobDefinition.targetType === 'PRINTIX') {
                dataExtractOjbect.jobDefinition.PRINTIX = jobDefinition
              }

            })
          } 

          return checkJobDefinitionObject();
        }

        function checkJobDefinitionObject() {
          for(var key in dataExtractOjbect.jobDefinition) {
            if (!dataExtractOjbect.jobDefinition[key]) {
              dataExtractOjbect.jobDefinition[key] = new JobDefinitionModel();
              dataExtractOjbect.jobDefinition[key].targetType = key;
            }
          }
          return true;
        }

      }
    ])

})();